import type { TFunction } from "i18next"
import { formatTimeUnit } from "./formatTimeUnit"

/**
 * Displays a relative timestamp (e.g., "3h", "2d", "Just now")
 * Used across multiple components for consistent timestamp formatting
 */
export const displayTimestamp = (
  timestamp: string,
  t: TFunction,
  locale: string
) => {
  const time = new Date(timestamp)
  const now = new Date()
  const difference = now.getTime() - time.getTime()

  const ONE_HOUR = 60 * 60 * 1000
  const ONE_DAY = 24 * ONE_HOUR
  const THREE_DAYS = 3 * ONE_DAY

  const hours = Math.floor(difference / ONE_HOUR)
  const days = Math.floor(difference / ONE_DAY)

  if (difference < ONE_HOUR) return t("date.JUST_NOW")
  if (difference < ONE_DAY)
    return formatTimeUnit(hours, "date.HOUR_SHORT", t, locale)
  if (difference < THREE_DAYS)
    return formatTimeUnit(days, "date.DAY_SHORT", t, locale)
  return t("date.A_WHILE_AGO")
}
